import axios from 'axios';

const baseURL = '/'

// eslint-disable-next-line
const env = process.env;
var axiosInstance = axios.create({baseURL});

axiosInstance.addToken = (token, type = 'Bearer') => {
    const authorizationHeaderValue = `${type} ${token}`;
    axiosInstance.defaults.headers.common['Authorization'] =
        authorizationHeaderValue;
    return authorizationHeaderValue;
};

axiosInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // Вход истёк или токен отозван — на страницу входа, вернуться туда же после входа.
        if (error.response?.status === 401 && !/\/auth\/(xml-login|egov)/.test(String(error.config?.url ?? ''))) {
            localStorage.removeItem('token');
            delete axiosInstance.defaults.headers.common['Authorization'];
            const redirect = window.location.pathname + window.location.search;
            if (window.location.pathname !== '/') {
                window.location = '/?redirect=' + encodeURIComponent(redirect);
            }
        }

        return Promise.reject(error);
    }
);
export default axiosInstance;
